import { DatePipe, LOCATION_INITIALIZED, TitleCasePipe } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  APP_INITIALIZER,
  Injector,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  ErrorHandler
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// reCaptcha
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TenantConfService } from './services/tenant-conf.service';
import { NewsletterModalComponent } from './shared/components/newsletter-modal/newsletter-modal.component';
import { ErrorsInterceptor } from './shared/interceptors/errors.interceptor';
import { LanguageInterceptor } from './shared/interceptors/language.interceptor';
import { RequestInterceptor } from './shared/interceptors/request.interceptor';
import { SharedModule } from './shared/shared.module';
import {Observable} from "rxjs";
import {environment} from "../environments/environment";
import { CoreServicesConfig, getProviders }  from '@syntonize/merlin-core';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`/assets/i18n/${lang}.json`);
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

const tenantUuid = environment.tenantByUrl[window.location.host]

const config: CoreServicesConfig = {
  env: environment.env as "local" | "dev" | "prod",
  tenantUuid,
  project: 'web',
  defaultLanguage: environment.tenants[tenantUuid].allowedLanguages[0]
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    // NgxJsonLdModule,
    // ngx-translate and the loader module
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [
    // StatusBar,
    // SplashScreen,
    DatePipe,
    TitleCasePipe,
    CookieService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector, TenantConfService],
      multi: true,
    },
    ...getProviders(config, HttpClient, HTTP_INTERCEPTORS, ErrorHandler)
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService, injector: Injector, tenantService: TenantConfService) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      locationInitialized.then(() => {
        const langToSet = tenantService.getLanguage();
        translate.setDefaultLang(langToSet);
        translate.use(langToSet).subscribe(
          () => {}, //console.info(`Successfully initialized '${langToSet}' language.'`),
          (err) => {
            console.error(`Problem with '${langToSet}' language initialization. ${JSON.stringify(err, null, 2)}'`);
            resolve(null);
          },
          () => resolve(null)
        );
      });
    });
}
